export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';
